import React from 'react';
import { Typography } from '@mui/material';

import { Dialog } from '@paragon/popup-state';

function onGetMoreHelp() {
  window.open('https://paragontruss.com/help/sealing', '_blank');
}

export default function HelpPanel() {
  return (
    <Dialog
      title="Keyboard Shortcuts"
      cancelText="Close"
      onCancel="close"
      otherButtons={{
        'Get More Help': { handler: onGetMoreHelp },
      }}
    >
      <Typography>Zoom with the mousewheel</Typography>
      <Typography>Pan with left-click drag</Typography>
      <Typography>Double click a block of text to edit it</Typography>
      <Typography>Draw lines with Alt + left-click drag</Typography>
      <Typography>Draw freeform with Alt + Shift + left-click drag</Typography>
      <Typography>Select and move a portion of the image with Ctrl + Alt + left click drag</Typography>
      <Typography>Whiteout a portion of the PDF with Ctrl + Shift + left click drag</Typography>
      <Typography>Select items by clicking them; deselect by clicking again</Typography>
      <Typography>Select another item with Ctrl + left click</Typography>
      <Typography>Select all items on a page with Ctrl + A</Typography>
      <Typography>Select a group of items with Ctrl + drag</Typography>
      <Typography>Copy and paste selected items with Ctrl + C and Crtl + V</Typography>
      <Typography>Undo recent changes with Ctrl + Z and redo them with Ctrl + Y</Typography>
      <Typography>Move selected items by dragging one of them</Typography>
      <Typography>Hold Alt while dragging a line endpoint to extend the line</Typography>
      <Typography>Resize selected items with + and -</Typography>
      <Typography>Change the weight of a path with Alt+ and Alt-</Typography>
      <Typography>Deselect selected items with Escape</Typography>
      <Typography>Jump to first document with Page Up</Typography>
      <Typography>Jump to last document with Page Down</Typography>
    </Dialog>
  );
}
